module.exports = __webpack_public_path__ + "img/student2.f2630ea6.png";